const backendUrl = "https://staging.crm.theincircle.com";
// const backendUrl = "http://localhost:3700";

export {
  backendUrl,
};
